// Angular
import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable()
export class SEOService {

    constructor(private title: Title, private meta: Meta) { }

    updateTitle(title: string): void {
        // console.log('updateDescription', {title});
        this.title.setTitle(title);
    }

    updateDescription(desc: string): void {
        // console.log('updateDescription', {desc});
        this.meta.updateTag({ name: 'description', content: desc });
    }
}
